"use client";

import React from "react";
import { cn } from "utils";
import NextImage from "../NextImage";
import Translations from "@translate/components/Setting/TurnOnNotificationContent";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

/** 贴图默认路径，贴图需放在 public/assets/images 下 */
const DEFAULT_ILLUSTRATION_SRC = "/assets/images/notifications-modal-light.svg";

export interface TurnOnNotificationContentProps {
  /** 点击「Yes, Notify me」 */
  onConfirm: () => void;
  /** 点击「Maybe Later」 */
  onMaybeLater: () => void;
  /** 根节点类名 */
  className?: string;
  /** 顶部插画图片地址，不传则使用默认路径 */
  imageSrc?: string;
}

/**
 * 开启通知引导弹窗 - 内容层
 * 对应设计稿 Frame 2147227898，含插画、标题、权限行+Switch、按钮组
 */
export const TurnOnNotificationContent: React.FC<
  TurnOnNotificationContentProps
> = ({
  onConfirm,
  onMaybeLater,
  className,
  imageSrc = DEFAULT_ILLUSTRATION_SRC,
}) => {
  return (
    <div className={cn("flex w-full flex-col items-center gap-6", className)}>
      {/* 标题区块：插画 + 主标题 */}
      <div className="flex w-full flex-col items-center gap-4">
        {/* Group 2147231562 贴图 */}
        <div className="relative h-[77px] w-full min-w-0 max-w-[169px]">
          <NextImage
            src={imageSrc}
            alt=""
            width={169}
            height={77}
            className="h-full w-full object-contain object-center"
          />
        </div>
        <h2
          aria-label="Turn On Notification Content h2"
          data-openreplay-label="my_turnonnotificationcontent_h2"
          id="sem-turn-on-notification-content-h2"
          className="headline_regular_s text-center text-content_primary"
        >
          {I18n.t("Let Ed keep an eye out")}
        </h2>
        <p className="body_m text-content_secondary text-center -mt-2">
          {I18n.t(
            "Turn on alerts and Ed will flag the moves worth a look on the things you're tracking.",
          )}
        </p>
      </div>
      {/* 按钮组 */}
      <div className="flex w-full flex-col gap-2">
        <button
          aria-label="Turn On Notification Content"
          data-openreplay-label="my_turnnotificationcontent_click"
          id="btn-turn-on-notification-content"
          type="button"
          className="button sm_button primary_button button_m flex h-11 w-full items-center justify-center rounded-2 text-content_inverse_primary"
          onClick={onConfirm}
        >
          {I18n.t("Yes, Notify me")}
        </button>
        <button
          aria-label="Turn On Notification Content"
          data-openreplay-label="my_turnnotificationcontent_click"
          id="btn-turn-on-notification-content-2"
          type="button"
          className="button sm_button button_m flex h-11 w-full items-center justify-center rounded-2 bg-transparent text-content_primary"
          onClick={onMaybeLater}
        >
          {I18n.t("Maybe Later")}
        </button>
      </div>
    </div>
  );
};
